import React, { Component, KeyboardEvent } from 'react';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import b from 'b_';

import './side-nav.css';

import { HeadMenuItem } from '@interfaces/head-menu';
import { isExternalUrl } from 'client/helpers/isExternalUrl';
import { AppDataProps } from 'client/contexts/app-data';

export interface StateProps {
    links: HeadMenuItem[];
    pathname: string;
}

export interface ComponentProps {
    className?: string;
    onClose(): void;
    onSearch(search: string): void;
}

export type Props = ComponentProps & AppDataProps & StateProps & RouteComponentProps<any>;

const class_ = b.with('side-nav');

export default class SideNav extends Component<Props> {

    public onSearchKey = (e: KeyboardEvent) => {
        const { value } = (e.currentTarget as any);

        if (e.key === 'Enter' && value.trim()) {
            this.props.onSearch(value);
        }
    };

    public onCloseClick = () => {
        this.props.onClose();
    };

    public renderGeneralMenu() {
        const { appData } = this.props;
        const menu = [...appData.headMenu].reverse();

        return (
            <div className={class_('general-menu')}>
                {menu.map(({ link, title, active = false }, index) => (
                    <a
                        key={index.toString() + link}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={class_('general-menu-item', { active })}
                    >
                        {title}
                    </a>
                ))}
            </div>
        );
    }

    public renderMenu() {
        const { links } = this.props;

        return (
            <div className={class_('menu')}>
                {links.map(link => isExternalUrl(link.link)
                    ? this.renderExternalLink(link)
                    : this.renderLink(link)
                )}
            </div>
        );
    }

    public renderExternalLink({ link, title }: HeadMenuItem) {
        return (
            <a
                key={title}
                href={link}
                className={class_('menu-item')}
            >
                {title}
            </a>
        );
    }

    public renderLink({ link, title }: HeadMenuItem) {
        return (
            <NavLink
                exact={link === '/'}
                key={title}
                to={link}
                className={class_('menu-item')}
                activeClassName={class_('menu-item', { active: true })}
            >
                {title}
            </NavLink>
        );
    }

    public render() {
        const { className } = this.props;
        const classes = [class_()];

        if (className) {
            classes.push(className);
        }

        return (
            <div className={classes.join(' ')}>
                <div
                    className={class_('close')}
                    onClick={this.onCloseClick}
                />

                {this.renderGeneralMenu()}
                {this.renderMenu()}

                <div className={class_('search-wrap')}>
                    <input
                        placeholder="Search"
                        className={class_('search-input')}
                        onKeyDown={this.onSearchKey}
                    />
                </div>
            </div>
        );
    }
}
